import { Component } from '@angular/core';

@Component({
  selector: 'app-ussd-commands-page',
  templateUrl: './ussd-commands-page.component.html',
  styleUrls: ['./ussd-commands-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class UssdCommandsPageComponent {

}
